import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentList16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconDocumentList16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h4v5h5zm-.02-7H9V2.175a1 1 0 0 1 .102.08l.668-.743-.668.744 3.566 3.2A1 1 0 0 1 12.98 6m.356-1.288-3.566-3.2A2 2 0 0 0 8.434 1H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6.2a2 2 0 0 0-.664-1.488M7 9.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m.5 1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM6 9.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M5.5 12a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentList16);
